module.exports = __webpack_public_path__ + "img/main-1.63cac91e.png";